<template>
  <section>
    <b-table
      fixed
      striped
      stacked="lg"
      show-empty
      :fields="fields"
      :items="schedules"
    >
      <template #cell(schedule_date)="data">
        {{ data.value.slice(0, 10) }}
      </template>
      <template #cell(name)="data">
        <a
          href="javascript:void(0)"
          @click="showScheduleOverview(data.item)"
          v-if="data.item.overview"
        >
          {{ data.value }}
        </a>
        <span v-else>{{ data.value }}</span>
      </template>
      <template #cell(live_streaming)="data">
        <b-button
          variant="primary"
          @click="showScheduleLiveStreaming(data.item)"
          v-if="getLiveStreamingUrl(data.item.places)"
        >
          {{ $t('event.detail.schedule.button.livestream.label') }} <b-icon icon="play"></b-icon>
        </b-button>
        <span v-else>{{ $t('event.detail.schedule.message.none') }}</span>
      </template>
      <template #empty="scope">
        <h5>{{ $t('event.detail.schedule.message.none') }}</h5>
      </template>
    </b-table>
    <b-modal
      centered
      size="lg"
      id="schedule-overview"
      :title="schedule_name"
    >
      <p>{{ schedule_overview }}</p>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
    <b-modal
      centered
      size="lg"
      id="schedule-live-streaming"
      :title="schedule_name"
    >
      <live-streaming-player :source="schedule_live_streaming_url"></live-streaming-player>       
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </section>
</template>
<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'

import LiveStreamingPlayer from '@/components/players/LiveStreamingPlayer'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)
Vue.use(ModalPlugin)
Vue.use(TablePlugin)

export default {
  i18n,
  name: 'event-schedule-list',
  props: {
    schedules: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      schedule_name: '',
      schedule_overview: '',
      schedule_live_streaming_url: ''
    }
  },
  computed: {
    fields() {
      return [
        { key: 'schedule_date', label: this.$t('event.detail.schedule.table.header.date') },
        { key: 'start_time', label: this.$t('event.detail.schedule.table.header.start-time') },
        { key: 'end_time', label: this.$t('event.detail.schedule.table.header.end-time') },
        { key: 'name', label: this.$t('event.detail.schedule.table.header.name') },
        { key: 'leader', label: this.$t('event.detail.schedule.table.header.leader') },
        { key: 'live_streaming', label: this.$t('event.detail.schedule.table.header.livestream') }
      ]
    }
  },
  methods: {
    showScheduleOverview(schedule) {
      this.schedule_name = schedule.name
      this.schedule_overview = schedule.overview
      this.$bvModal.show('schedule-overview')
    },
    showScheduleLiveStreaming(schedule) {
      this.schedule_name = schedule.name
      this.schedule_live_streaming_url = this.getLiveStreamingUrl(schedule.places)
      this.$bvModal.show('schedule-live-streaming')

      gtag('event', `watch event-schedule live`, {
        code: schedule.id,
        name: schedule.name,
      })
    },
    getLiveStreamingUrl(places) {
      let live_streaming_place = places.filter(
        item => item.pivot.offer_live_streaming === 'Y' && item.live_streaming_url
      ).shift();

      return live_streaming_place !== undefined ? live_streaming_place.live_streaming_url : '';
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    LiveStreamingPlayer
  }
}
</script>